"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Error_exports = {};
__export(Error_exports, {
  ClerkAPIResponseError: () => ClerkAPIResponseError,
  MagicLinkError: () => MagicLinkError,
  MagicLinkErrorCode: () => MagicLinkErrorCode,
  isClerkAPIResponseError: () => isClerkAPIResponseError,
  isKnownError: () => isKnownError,
  isMagicLinkError: () => isMagicLinkError,
  isMetamaskError: () => isMetamaskError,
  parseError: () => parseError,
  parseErrors: () => parseErrors
});
module.exports = __toCommonJS(Error_exports);
function isKnownError(error) {
  return isClerkAPIResponseError(error) || isMetamaskError(error);
}
function isClerkAPIResponseError(err) {
  return "clerkError" in err;
}
function isMetamaskError(err) {
  return "code" in err && [4001, 32602, 32603].includes(err.code) && "message" in err;
}
function parseErrors(data = []) {
  return data.length > 0 ? data.map(parseError) : [];
}
function parseError(error) {
  return {
    code: error.code,
    message: error.message,
    longMessage: error.long_message,
    meta: {
      paramName: error?.meta?.param_name,
      sessionId: error?.meta?.session_id,
      emailAddresses: error?.meta?.email_addresses,
      zxcvbn: error?.meta?.zxcvbn
    }
  };
}
class ClerkAPIResponseError extends Error {
  constructor(message, { data, status }) {
    super(message);
    this.toString = () => {
      return `[${this.name}]
Message:${this.message}
Status:${this.status}
Serialized errors: ${this.errors.map(
        (e) => JSON.stringify(e)
      )}`;
    };
    Object.setPrototypeOf(this, ClerkAPIResponseError.prototype);
    this.status = status;
    this.message = message;
    this.clerkError = true;
    this.errors = parseErrors(data);
  }
}
class MagicLinkError extends Error {
  constructor(code) {
    super(code);
    this.code = code;
    Object.setPrototypeOf(this, MagicLinkError.prototype);
  }
}
function isMagicLinkError(err) {
  return err instanceof MagicLinkError;
}
const MagicLinkErrorCode = {
  Expired: "expired",
  Failed: "failed"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ClerkAPIResponseError,
  MagicLinkError,
  MagicLinkErrorCode,
  isClerkAPIResponseError,
  isKnownError,
  isMagicLinkError,
  isMetamaskError,
  parseError,
  parseErrors
});
//# sourceMappingURL=Error.js.map